module.exports = __webpack_public_path__ + "img/westcliff.362dc7a7.webp";